import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Const from 'constants';
import TeamStack from './components/team-stack';

class NHLPlayerNameStack extends Component {
    useFilter(use) {
        this.props.dispatch(Action.do('useNHLNameStack', !use));
        if (!use) {
            this.props.dispatch(Action.do('useNHLNonControlledStack', use));
        }
    }

    setStackMode(isDouble) {
        this.props.dispatch(Action.set('NHLNameDoubleStackMode', isDouble));
    }

    render() {
        let {sportConfig, stack} = this.props;

        if (!sportConfig.isReady()) {
            return false;
        }

        return (
            <div className={`advanced-filter${stack.useStack ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.useFilter(stack.useStack)}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable controlled stack by name
                    </button>
                    <button type="button" onClick={(e) => ::this.useFilter(stack.useStack)} className="advanced-opener">
                        <i className="fa fa-cog"></i>Enable controlled stack by name
                    </button>
                </div>

                <div className="white-box">
                    <h2 className="mb15">Controlled stack by name</h2>
                    <div className="checkbox mb20">
                        <label>
                            <input
                                type="checkbox"
                                checked={stack.isDoubleStackMode}
                                onChange={(e) => ::this.setStackMode(e.target.checked)}
                            />
                            Double stacking
                        </label>
                    </div>
                    <div className="team-filter">
                        <TeamStack groupNumber={Const.NHL_NAME_STACK_FIRST_GROUP} />

                        {stack.isDoubleStackMode ? <TeamStack groupNumber={Const.NHL_NAME_STACK_SECOND_GROUP} /> : null}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {games, filters: playersFilter} = state.playersData;
    const {sportConfig, stacks} = state;
    return {
        games,
        sportConfig,
        playersFilter,
        stack: stacks.nhlName,
    };
}

export default connect(mapStatesToProps)(NHLPlayerNameStack);
